import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/guards/auth.guard';
import { AutoLoginGuard } from './helpers/guards/auto-login.guard';
import { CommonModule } from '@angular/common';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    redirectTo: 'users/sign_in',
    pathMatch: 'full'
  },
  {
    path: 'users/sign_in',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canLoad: [AutoLoginGuard],
  },
  {
    path: 'accident',
    loadChildren: () => import('./pages/accident/accident.module').then(m => m.AccidentPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'document_management',
    loadChildren: () => import('./pages/document-management/document-management.module').then(m => m.DocumentManagementPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'instruction',
    loadChildren: () => import('./pages/instruction/instruction.module').then(m => m.InstructionPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/plans',
    loadChildren: () => import('./pages/hs/overview/overview.module').then(m => m.OverviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/plans',
    loadChildren: () => import('./pages/risk-assessment/overview/overview.module').then(m => m.OverviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/reports',
    loadChildren: () => import('./pages/risk-assessment/risk-assessment-reports/risk-assessment-reports.module').then(m => m.RiskAssessmentReportsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/risk_assessments',
    loadChildren: () => import('./pages/risk-assessment/risk-assessment-list/risk-assessment-list.module').then(m => m.RiskAssessmentListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/risk_assessments/:id',
    loadChildren: () => import('./pages/risk-assessment/risk-assessment-show/risk-assessment-show.module').then(m => m.RiskAssessmentShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/operating_instructions',
    loadChildren: () => import('./pages/risk-assessment/operating-instructions/operating-instructions.module').then(m => m.OperatingInstructionsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/risk_assessments/:id/operating-instructions/:color',
    loadChildren: () => import('./pages/risk-assessment/operating-instructions/operating-instruction-preview/operating-instruction-preview.module').then( m => m.OperatingInstructionPreviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/templates',
    loadChildren: () => import('./pages/risk-assessment/templates/templates.module').then(m => m.TemplatesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/template_management/common_templates',
    loadChildren: () => import('./pages/risk-assessment/common-templates/common-templates.module').then(m => m.CommonTemplatesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/template_management/common_templates/:id',
    loadChildren: () => import('./pages/risk-assessment/common-templates/common-template-show/common-template-show.module').then(m => m.CommonTemplateShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/templates/:id',
    loadChildren: () => import('./pages/risk-assessment/templates/template-show/template-show.module').then(m => m.TemplateShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/categories',
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/legal_cadastre',
    loadChildren: () => import('./pages/risk-assessment/legal-cadastre/legal-cadastre.module').then(m => m.LegalCadastrePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/events',
    loadChildren: () => import('./pages/risk-assessment/events/events.module').then(m => m.EventsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'risk_assessment/events/:id',
    loadChildren: () => import('./pages/risk-assessment/events/event-show/event-show.module').then(m => m.EventShowModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/hazardous_substances',
    loadChildren: () => import('./pages/hs/hazardous-substance-list/hazardous-substance-list.module').then(m => m.HazardousSubstanceListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/hazardous_substances/:id',
    loadChildren: () => import('./pages/hs/hazardous-substance-show/hazardous-substance-show.module').then(m => m.HazardousSubstanceShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/risk_assessments',
    loadChildren: () => import('./pages/hs/risk-assessment/risk-assessment-list/risk-assessment-list.module').then(m => m.HazardousSubstanceRiskAssessmentListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/risk_assessments/:id',
    loadChildren: () => import('./pages/hs/risk-assessment/risk-assessment-show/risk-assessment-show.module').then(m => m.HazardousSubstanceRiskAssessmentShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/categories',
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/suppliers',
    loadChildren: () => import('./pages/hs/suppliers/suppliers.module').then(m => m.SuppliersPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/manufacturers',
    loadChildren: () => import('./pages/hs/manufacturers/manufacturers.module').then(m => m.ManufacturersPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/cadaster',
    loadChildren: () => import('./pages/hs/cadaster/cadaster.module').then(m => m.CadasterPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/warehouses',
    loadChildren: () => import('./pages/hs/warehouses/warehouses.module').then(m => m.WarehousesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/warehouses/:id',
    loadChildren: () => import('./pages/hs/warehouses/warehouse-show/warehouse-show.module').then(m => m.WarehouseShowModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/events',
    loadChildren: () => import('./pages/hs/events/events.module').then(m => m.EventsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/events/:id',
    loadChildren: () => import('./pages/hs/events/event-show/event-show.module').then(m => m.EventShowModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/operating_instructions',
    loadChildren: () => import('./pages/hs/operating-instructions/operating-instructions.module').then(m => m.OperatingInstructionsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'hazardous_substance/hazardous_substances/:id/operating-instructions/:color',
    loadChildren: () => import('./pages/hs/operating-instructions/operating-instruction-preview/operating-instruction-preview.module').then( m => m.OperatingInstructionPreviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/plans',
    loadChildren: () => import('./pages/prevention/prevention-overview/prevention-overview.module').then( m => m.PreventionOverviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/templates',
    loadChildren: () => import('./pages/prevention/prevention-templates/prevention-templates.module').then( m => m.PreventionTemplatesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/categories',
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/plans',
    loadChildren: () => import('./pages/prevention/prevention-overview/prevention-overview.module').then(m => m.PreventionOverviewPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/users',
    loadChildren: () => import('./pages/prevention/prevention-users/prevention-users.module').then(m => m.PreventionUsersPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/events',
    loadChildren: () => import('./pages/prevention/prevention-events/prevention-events.module').then(m => m.PreventionEventsPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'organization/groups',
    loadChildren: () => import('./pages/organization/groups/groups-list/groups-list.module').then(m => m.GroupsListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'organization/groups/:id',
    loadChildren: () => import('./pages/organization/groups/group-show/group-show.module').then(m => m.GroupShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'organization/users',
    loadChildren: () => import('./pages/organization/users/users-list/users-list.module').then(m => m.UsersListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'organization/users/:id',
    loadChildren: () => import('./pages/organization/users/user-show/user-show.module').then(m => m.UserShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'organization/import_export',
    loadChildren: () => import('./pages/organization/import-export/import-export.module').then( m => m.ImportExportPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'clients/users',
    loadChildren: () => import('./pages/clients/users/users-list/users-list.module').then(m => m.UsersListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'clients/users/:id',
    loadChildren: () => import('./pages/clients/users/user-show/user-show.module').then(m => m.UserShowPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'clients/clients',
    loadChildren: () => import('./pages/clients/clients-list/clients-list.module').then(m => m.ClientsListPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'service_report',
    loadChildren: () => import('./pages/external-safety-service-provider/external-safety-service-provider.module').then( m => m.ExternalSafetyServiceProviderPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'prevention/users/user_profile/:id',
    loadChildren: () => import('./pages/prevention/prevention-user-profile/prevention-user-profile.module').then( m => m.PreventionUserProfilePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'template_management',
    loadChildren: () => import('./pages/template-management/template-management.module').then( m => m.TemplateManagementPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'servers',
    loadChildren: () => import('./pages/on-premise-servers/on-premise-servers-list/on-premise-servers-list.module').then(m => m.OnPremiseServersListPageModule),
    canLoad: [AuthGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
